module.exports = require('./helpers/bundle-url').getBundleURL('gA8FI') + "box.2a34708a.webp";